import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getJwt } from '@jane/shared/auth';
import { janeApi } from '@jane/shared/data-access';

import type {
  CreateQuickCartParams,
  CreateQuickCartResponse,
} from './quickCart.types';
import { quickCartQueryKeys, quickCartUrls } from './quickCart.util';

const createQuickCart = (cart: CreateQuickCartParams) => {
  const fullCart = {
    ...cart,
    user_agent: navigator.userAgent,
  };

  return janeApi.post<CreateQuickCartResponse>(
    quickCartUrls.quickCart,
    fullCart,
    getJwt()
  );
};

export const useCreateQuickCart = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createQuickCart,
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: quickCartQueryKeys.anyQuickCart(),
      });
    },
  });
};
